import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import PropertiesSection from './components/PropertiesSection';
import JalsaLegacy from './components/JalsaLegacy';
import EventsSection from './components/EventsSection';
import BarLoungeSection from './components/BarLoungeSection';
import BhopalGuide from './components/BhopalGuide';
import InstagramSection from './components/InstagramSection';
import TestimonialsSection from './components/TestimonialsSection';
import LocationSection from './components/LocationSection';
import Footer from './components/Footer';
import PropertyDetail from './pages/PropertyDetail';
import BarLoungePage from './pages/BarLoungePage';
import ThankYouPage from './pages/ThankYouPage';
import './styles/animations.css';
import './index.css';

// Homepage Component
function HomePage() {
  return (
    <>
      <Hero />
      <PropertiesSection />
      <JalsaLegacy />
      <EventsSection />
      <BarLoungeSection />
      <BhopalGuide />
      <InstagramSection />
      <TestimonialsSection />
      <LocationSection />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/properties/:slug" element={<PropertyDetail />} />
            <Route path="/bar-lounge" element={<BarLoungePage />} />
            <Route path="/thank-you" element={<ThankYouPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
